import { MentionTypes } from '@lyearn/lygo-blocks';
import useLearners from '@/modules/corporate/modules/learners/hooks/useLearners';
import { MentionEntityTypeEnum, UserType } from '@/types/schema';

import { ALLOWED_USER_STATUS } from '../../consts';
import { MentionsData } from '../../types';
import { MentionsEntity } from '../types';
import BaseLearnerItem from './BaseLearnerItem';

const useUserSearch = ({ searchString }: { searchString?: string }) => {
  const { learners, isFetching: fetching } = useLearners({
    filters: {
      searchText: searchString,
      status: ALLOWED_USER_STATUS,
    },
  });

  // TODO @HimanshuSahu31 refactor explicit type cast
  return { data: learners as UserType[], fetching };
};

const UserMention: MentionsEntity<UserType> = {
  getMentionNodeAttrs: (item: UserType) => ({
    type: MentionTypes.User,
    id: item.id,
    name: item.name || '',
  }),
  useSearch: useUserSearch,
  getInitialItems: (items?: MentionsData) => items?.users,
  BaseItem: BaseLearnerItem,
  type: MentionEntityTypeEnum.User,
};

export default UserMention;
